<template>
  <div class="modal__wrap--bg cmp-modal" :class="{ 'is-active' : withdrewModal}" id="withdrew-modal-template" v-if="withdrewModal">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">회원탈퇴</div>
      </div>
      <div class="modal-body-container">
        <h5 class="title-type mt-32">탈퇴하시겠습니까?</h5>
        <div class="text-box-section mt-8">
          회원탈퇴 시 아래 사항을 확인해주세요.
        </div>
        <div class="border-line-box">
          <ol class="out-notice-list">
            <li>탈퇴 시 해당 아이디의 사용은 불가합니다. 50플러스 포털을 이용하시기 위해서는 다시 회원가입을 진행하셔야 합니다.</li>
            <li>회원탈퇴 후 개인정보는 개인정보 처리방침에 따라 즉시 폐기됩니다.</li>
            <li>활동정보(강좌 수강정보, 상담정보, 일자리 정보 등)는 활동확인서 등 증빙자료 출력 등을 위해 유지되며, 활동정보 외 데이터는 탈퇴 시 즉시 폐기되어, 새로 회원가입한 아이디로 연동은 불가합니다.</li>
          </ol>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          취소
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="withdraw">
          탈퇴
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'withdrew-modal-template',
    props: ['withdrewModal'],
    data() {
      return {
      };
    },
    methods: {
      withdraw() {
        const result = window.confirm('정말 탈퇴하시겠습니까?');
        if (result) {
          axios.post('/api/members/leave-member', {
          }).then(() => {
            alert('탈퇴 처리 되었습니다. 감사합니다.');
            location.href = '/';
          }).catch((error) => {
            alert(error.response.data.msg);
          });
        }
      },
      close() {
        this.withdrewModal = false;
        $('body').removeClass('modal-open');
        this.$emit('withdrewModal-close', {});
      },
    },
  };
</script>



// WEBPACK FOOTER //
// WithdrewModal.vue?66b61b38